import { HttpClient } from '@services/http/client/http-client';
import { useContext, createContext } from 'react';

const HttpClientContext = createContext();

export function HttpClientCtxProvider({ children }) {
  const client = new HttpClient();
  return <HttpClientContext.Provider value={client}>{children}</HttpClientContext.Provider>;
}

export function useHttpClient() {
  const client = useContext(HttpClientContext);

  const executeRemoteCall = (remoteCall) => {
    return client.execute(remoteCall);
  };

  return { executeRemoteCall };
}
